import HTTP from './http'
import { AxiosResponse } from 'axios'
import { getToken } from 'utils/auth'
import { API_HEADER_CONTENT_TYPE as HEADER } from './constants'
import { IHTTPVerbsData } from './interface'

export const featureFlagsByUserGet = ({ id, token }: IHTTPVerbsData) =>
  HTTP.panel.get(`/v1/feature-flags`, {
    headers: {
      ...HEADER.auth.bearer(token),
      ...HEADER.entityId.getFromValue(id),
      ...HEADER.json
    }
  })

export const featureFlagsUpdatePut = ({ data, entityId, flagId, flagKey }: IHTTPVerbsData): Promise<AxiosResponse> =>
  HTTP.panel.put('/v1/feature-flags', JSON.stringify({ id: flagId, key: flagKey, value: data }), {
    headers: {
      ...HEADER.auth.bearer(getToken()),
      ...HEADER.entityId.getFromValue(entityId),
      ...HEADER.json
    }
  })
